import React, { useState, useEffect } from 'react';

import './index.css';

const Projects = () => {
    const URL = `${process.env.PUBLIC_URL}/_data/home/projects.json`;

    const [content, setContent] = useState([]);

    useEffect(() => {
        // GET QuickLinks
        fetch(URL)
            .then((res) => res.json())
            .then((reply) => {
                setContent(reply);
            });
    }, []);

    const setCoInvestigator = (coinvestigator) => {
        if (coinvestigator && coinvestigator.length > 0) {
            return (
                <p>
                    <span className="project-block">Co-Investigators: </span>
                    {coinvestigator.map((item, index) => {
                        return (
                            <span key={index}>
                                {(() => {
                                    if (index !== 0) return <span>&bull;</span>;
                                    return '';
                                })()}
                                &nbsp;&nbsp;{item}&nbsp;&nbsp;
                            </span>
                        );
                    })}
                </p>
            );
        }

        return '';
    };
    return (
        <div className="projects" id="Projects">
            <h3>Projects</h3>
            <ul>
                {content.map((item, index) => {
                    return (
                        <li key={index}>
                            <p>
                                <span className="project-block">Title: </span>
                                {item.title}
                            </p>
                            <p>
                                <span className="project-block">Principal Investigator: </span>
                                {item.principalInvestigator}
                            </p>
                            {setCoInvestigator(item.coInvestigators)}
                            <p>
                                <span className="project-block">Sponsored Agency: </span>
                                {item.sponsoredAgency}
                            </p>
                            <p>
                                <span className="project-block">Status: </span>
                                {item.status}
                            </p>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default Projects;
